import { NavLink, useParams } from "react-router-dom";
import { Button, Grid, Typography } from "@mui/material";
import { AddCircle as AddCircleIcon } from "@mui/icons-material";
import * as L from "leaflet";
import { useTranslation } from "react-i18next";

import { Pane } from "src/components/Pane";
import { LEZList } from "src/components/LEZList";
import { IsEnabled } from "src/components/permissions";
import { useLEZs } from "src/hooks";
import { useScenario } from "src/hooks/useScenario";
import { LEZRoadsOnMap } from "src/components/on-map/LEZRoadsOnMap";

interface Props {
  map: L.Map;
}

export function LEZsPage(props: Props) {
  const { t } = useTranslation();
  const {scenarioId = "", caseId = ""} = useParams<{
    caseId: string;
    scenarioId: string;
  }>();
  const { data: scenario } = useScenario(scenarioId);
  const { data: lezsData } = useLEZs(scenarioId);

  // useLEZRoadsOnMap(props.map, params.scenarioId);

  return render();

  function render() {
    if (!scenario || !lezsData) return null;

    return (
      <>
        <LEZRoadsOnMap scenarioId={scenarioId} />
        <Pane>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h2">{t("label.lowEmissionZones")}</Typography>
            </Grid>

            <LEZList lezs={lezsData.zones} scenario={scenario} />

            <IsEnabled permission={scenario.permissions.updateLEZ}>
              <Grid item xs={12}>
                <Button
                  startIcon={<AddCircleIcon />}
                  color="primary"
                  component={NavLink}
                  to={`/cases/${caseId}/scenarios/${scenarioId}/lezs/new`}
                >
                  {t("label.addLowEmissionZone")}
                </Button>
              </Grid>
            </IsEnabled>
          </Grid>
        </Pane>
      </>
    );
  }
}
